import { Button } from '@/components/ui/button';
import { DialogHeaderFallback } from './DialogHeader';
import { useTranslation } from 'react-i18next';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { Label } from '@/components/ui/label';
import Skeleton from '@/components/Skeleton/Skeleton';
import { FormFieldWrapper } from '@/domain/controlling/pages/Umsatzplanung/components/FormFieldWrapper';
import { useStandortContext } from '@/features/standortContext/StandortContext';

// eslint-disable-next-line max-lines-per-function
export function FallbackDialogContent() {
  const { t } = useTranslation();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige } = useTagebuchEinstellungen(standortId);

  return (
    <>
      <div className="flex flex-col gap-6 pt-8 pb-4">
        <DialogHeaderFallback />
        <form className="flex flex-col gap-6">
          {umsatzplanungAnzeige !== 'ABSATZ_PRODUKTIVITAET' && (
            <div className="flex justify-between gap-4">
              <FormFieldWrapper>
                <Label htmlFor="umsatzZiel">
                  {t(
                    'domain.controlling.umsatzplanung.ziele.dialog.umsatz.label',
                  )}
                </Label>
                <Skeleton.Field width="299px" height="42px" />
              </FormFieldWrapper>
              <FormFieldWrapper>
                <Label>
                  {t(
                    'domain.controlling.umsatzplanung.ziele.dialog.produktivitaet.label',
                  )}
                </Label>
                <Skeleton.Field width="299px" height="42px" />
              </FormFieldWrapper>
            </div>
          )}
          {umsatzplanungAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' && (
            <hr className="h-px bg-neutrals-300 border-0 col-span-2"></hr>
          )}
          {umsatzplanungAnzeige !== 'UMSATZ_PRODUKTIVITAET' && (
            <div className="flex justify-between gap-4">
              <FormFieldWrapper>
                <Label htmlFor="umsatzZiel">
                  {t(
                    'domain.controlling.umsatzplanung.ziele.dialog.absatz.label',
                  )}
                </Label>
                <Skeleton.Field width="299px" height="42px" />
              </FormFieldWrapper>
              <FormFieldWrapper>
                <Label>
                  {t(
                    'domain.controlling.umsatzplanung.ziele.dialog.produktivitaet.label',
                  )}
                </Label>
                <Skeleton.Field width="299px" height="42px" />
              </FormFieldWrapper>
            </div>
          )}
        </form>
      </div>
      <hr className="h-px bg-neutrals-300 border-0 -mx-8"></hr>
      <div className="flex items-center justify-between pb-4">
        <div className="flex items-center justify-end w-full gap-4">
          <Button disabled>
            {t('domain.controlling.umsatzplanung.ziele.fertig')}
          </Button>
        </div>
      </div>
    </>
  );
}
